import escapeRegExp from './escapeRegExp';
import { empty, WHITESPACE } from './_consts';
export default function trim(str, chars) {
    if (chars !== undefined) {
        chars = escapeRegExp(chars);
    }
    else {
        chars = WHITESPACE;
    }
    const regex = new RegExp(`^[${chars}]+|[${chars}]+$`, 'g');
    return str.replace(regex, empty);
}
